import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { insuranceproduct } from "../../Redux/actions/NumLife";
import { Previousinsurer } from "../../Redux/actions/NumBikeation";
import { Radio, Form, Row, Col, Select, Button, Input, Spin } from "antd/lib";
import "./policyStep.css";
import { useHistory } from "react-router-dom";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import income from "./IncomeOption";
function PolicySteps2(props) {
  console.log(props.preinslist);
  const lifeDetail = useSelector((state) => state.lifedetail.lifenum);
  const [form] = Form.useForm();

  const [open, setOpen] = React.useState(false);
  const [product, setproduct] = useState([]);
  let history = useHistory();
  const dispatch = useDispatch();
  console.log(lifeDetail);
  // console.log(
  //   "Vehicle Details",
  //   vehicleDetails,
  //   JSON.parse(localStorage.getItem("vibeReg"))
  // );
  useEffect(() => {
    dispatch(Previousinsurer());
    dispatch(insuranceproduct())
      .then((res) => {
        console.log(res);
        setproduct(res);
      })
      .catch((err) => {});
  }, [dispatch]);

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    // setValue(e.target.value);
  };
  const onFinish = (values) => {
    console.log(values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  // const onSubmit = (data) => {
  //   console.log(data)
  //   setOpen(true);
  //   const auth = JSON.parse(localStorage.getItem("vibeReg"));
  //   const isuser = JSON.parse(localStorage.getItem("vibeUser"));
  //   if (isuser !== null) {
  //     var is_POSP = isuser.isPOSP === true ? 1 : 0;
  //     var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
  //   } else {
  //     is_POSP = 0;
  //     posp_id = "";
  //   }

  //   let post = {
  //     insuranceProductCode: data?.product,
  //     policyHolderType: data?.customertype,
  //     isVehicleNew: 0, //0 or 1 - Integer
  //     make: vehicleDetails?.make,
  //     model: vehicleDetails?.model,
  //     variant: vehicleDetails?.varcar,
  //     licensePlateNumber: auth?.bike_number,
  //     manufactureDate: data?.registrationdate,
  //     registrationDate: data?.registrationdate,
  //     previousPolicyExpiryDate: '2023-11-26',
  //     isPreviousInsurerKnown: 0, //0 or 1 - Integer
  //     previousInsurerCode: data?.insurer,
  //     isClaimInLastYear: 0,
  //     originalPreviousPolicyType: null,
  //     previousNoClaimBonus: 'ZERO',
  //     pincode: "630606",
  //     isPOSP: is_POSP,
  //     insurance_id: auth.bike_insurance_id,
  //   };
  //   console.log(post);
  //   // axiosInstance
  //   //   .post("v1/bike_insurance/quickquotes", post)
  //   //   .then((res) => {
  //   //     console.log("QuickQuotes", res);
  //   //     if (res.status === 200) {
  //   //       if (!res.data.error) {
  //   //         let data = {
  //   //           data: res.data.data,
  //   //           post: post,
  //   //         };
  //   //         localStorage.setItem("quickquotes", JSON.stringify(res.data.data));
  //   //         dispatch(quick_quotes(data));
  //   //         history.push("/planlayoutbike");
  //   //         setOpen(false);
  //   //       } else {
  //   //         setOpen(false);
  //   //         message.error(res.data.error.validationMessages.join(","));
  //   //       }
  //   //     }
  //   //   })
  //   //   .catch((err) => {
  //   //     console.log(err);
  //   //     setOpen(false);
  //   //     message.error("Something Went Wrong Please try again!");
  //   //   });
  // };

  return (
    <>
      <Spin spinning={open}>
        <NavbarJourney />
        <section
          className="bg-light py-4"
          style={{ minHeight: "calc(100vh - 110px)" }}
        >
          <div className="container">
            <div className="mb-5">
              <h3>Fill Some Information Below So We Can Provide Exact Quote</h3>
            </div>
            <div className="row">
              <Form
                // layout={formLayout}
                form={form}
                style={{ width: "100%" }}
                requiredMark={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row gutter={24}>
                  {/* <Col span={12}>
                  <div className="h6 text-blue mb-3 mb-3">Required Policy Type</div>
                  <Form.Item
                  {...formItemLayout}
                  className="form-item-bg"
                  label='Policy Type'
                  name="product"
                  rules={[
                    {
                      required: true,
                      message: 'Please select Policy Type',
                    },
                  ]}
                  >
                    <Radio.Group
                      className="py-3 px-3 bg-white ant-radio-layout"
                      onChange={onChange}
                       style={{
                          width: "100%",
                        }}
                      >
                        {product.map((e) => (
                          <Radio key={e.id} value={e.product_code}>
                            {e.product_name}
                          </Radio>
                        ))}
                      </Radio.Group>
                    </Form.Item>
                    </Col> */}
                  {/* <Col span={12}>
                    <div className="h6 text-blue mb-3">Select previous insurer</div>
                    <Form.Item 
                    {...formItemLayout}
                    className="form-item-bg"
                    label='Previous Insurer'
                    name='insurer'
                    rules={[
                      {
                        required: true,
                        message: 'Please select previous insurer',
                      },
                    ]}
                    >
                    <Select
                      defaultValue="Select your option"
                      // onChange={handleChange}
                      options={props.preinslist?.map((p) => ({
                        key: p.id,
                        value: p.code,
                        label:p.name
                      }))}
                    />
                    </Form.Item>
                    </Col> */}
                  <Col span={12}>
                    <div className="h6 text-blue mb-3">
                      Please Choose Your Occupation Type
                    </div>
                    <Form.Item
                      {...formItemLayout}
                      className="form-item-bg"
                      label="Occupation"
                      name="occupation"
                      rules={[
                        {
                          required: true,
                          message: "Please select Occupation",
                        },
                      ]}
                    >
                      <Radio.Group
                        className="py-3 px-3 bg-white ant-radio-layout"
                        style={{
                          width: "100%",
                        }}
                        // onChange={onChange}
                        // value={value}
                      >
                        <Radio value="Salaried">Salaried</Radio>
                        <Radio value="Self Employed">Self Employed</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <div className="h6 text-blue mb-3">
                      Select Your Anual Income
                    </div>
                    <Form.Item
                      {...formItemLayout}
                      label="Anual Income"
                      className="form-item-bg"
                      name="income"
                      rules={[
                        {
                          required: true,
                          message: "Please select Anual Income",
                        },
                      ]}
                    >
                      <Select
                        defaultValue="Select your Income"
                        // onChange={handleChange}
                        options={income?.map((p) => ({
                          key: p.id,
                          value: p.name,
                          label: p.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <div className="h6 text-blue mb-3">
                      Select Education Qualification
                    </div>
                    <Form.Item
                      {...formItemLayout}
                      className="form-item-bg"
                      label="Education"
                      name="education"
                      rules={[
                        {
                          required: true,
                          message: "Please select Qualification",
                        },
                      ]}
                    >
                      <Radio.Group
                        className="py-3 px-3 bg-white ant-radio-layout"
                        style={{
                          width: "100%",
                        }}
                      >
                        <Radio value="Post Graduate">Post Graduate</Radio>
                        <Radio value="Graduate">Graduate</Radio>
                        <Radio value="12th Pass">12th Pass</Radio>
                        <Radio value="10th Pass">10th Pass</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <div className="h6 text-blue mb-3">
                      Do You Smoke or Chew Tobaco
                    </div>
                    <Form.Item
                      {...formItemLayout}
                      label="Smoke ?"
                      className="form-item-bg"
                      name="smoke"
                      rules={[
                        {
                          required: true,
                          message: "Please select",
                        },
                      ]}
                    >
                      <Radio.Group
                        className="py-3 px-3 bg-white ant-radio-layout"
                        style={{
                          width: "100%",
                        }}
                        // onChange={onChange}
                        // value={value}
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <div className="h6 text-blue mb-3">Enter Email</div>
                    <Form.Item
                      {...formItemLayout}
                      className="form-item-bg"
                      label="Email"
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Please Input Email",
                        },
                      ]}
                      //initialValue={OwnerInfo?.Email}
                    >
                      <Input
                        autoComplete="off"
                        style={{ width: "100%" }}
                        placeholder="Email"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <div className="h6 text-blue mb-3">
                      {" "}
                      Previous No Claim Bonus (NCB)
                    </div>
                    <Form.Item
                      {...formItemLayout}
                      label="NCB"
                      className="form-item-bg"
                      name="ncbvalue"
                    >
                      <Select
                        defaultValue="20%"
                        disabled
                        // style={{
                        //   width: 120,
                        // }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <div
                  className="bg-white position-sticky bottom-0"
                  style={{ height: "50px" }}
                >
                  <div className="d-flex align-items-center justify-content-end container text-right py-2">
                    <p className="mb-0 mx-3">
                      By proceeding, you agree to the Terms & Conditions
                    </p>
                    <Form.Item className="mb-0" {...buttonItemLayout}>
                      <Button type="primary" htmlType="submit">
                        Get Quotes
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </section>
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    product: state.vehicledetail.insuranceproduct,
    preinslist: state.vehicledetail.previnslist,
  };
};

export default connect(mapStateToProps)(PolicySteps2);
